import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivityService } from 'app/services/activity.service';
import { AttributeFilterService, AttrFilter } from 'app/services/attribute-filter.service';
import { Subscription } from 'rxjs';
// import { FeatAttributeFiltersPopupComponent } from 'app/components/feat-attribute-filters-popup/feat-attribute-filters-popup.component';

@Component({
  selector: 'app-feat-attribute-filter-labels',
  templateUrl: './feat-attribute-filter-labels.component.html',
  styleUrls: ['./feat-attribute-filter-labels.component.css']
})
export class FeatAttributeFilterLabelsComponent implements OnInit, OnDestroy {

	attrFilters: AttrFilter[];

	colNameMap = {};

	private attrFiltersSub: Subscription;
	private applyAttrFilterSub: Subscription;
	private attrColumnSub: Subscription;

	constructor(
		private activityService: ActivityService,
		private attrFilterService: AttributeFilterService,
	) { }

	// clickLabel(idx: number) {
	// 	this.attrFilterService.openAttrFilter(FeatAttributeFiltersPopupComponent);
	// }
	removeFilter(idx: number) {
		this.attrFilters.splice(idx, 1);
		this.attrFilterService.attrFilters.next({
			filters: this.attrFilters,
			source: 'labels'
		});
	}

	ngOnInit() {
		this.attrFiltersSub = this.attrFilterService.attrFilters.subscribe(data => {
			if (data.source !== 'labels' && !data.skipGetData) {
				this.attrFilters = data.filters;
			}
		});
		this.applyAttrFilterSub = this.activityService.applyAttrFilterSubject.subscribe(() => {
			const data = this.attrFilterService.attrFilters.getValue();
			this.attrFilters = data.filters;
		});
		this.attrColumnSub = this.attrFilterService.attrFilterColumns.subscribe(data => {
			data.forEach(d => {
				this.colNameMap[d.prop] = d.name;
			});
		})
	}
	ngOnDestroy() {
		this.attrFiltersSub.unsubscribe();
		this.applyAttrFilterSub.unsubscribe();
		this.attrColumnSub.unsubscribe();
	}
}
